import { render, staticRenderFns } from "./user_host.vue?vue&type=template&id=3884ba42&scoped=true&lang=pug&"
import script from "./user_host.vue?vue&type=script&lang=js&"
export * from "./user_host.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3884ba42",
  null
  
)

export default component.exports